import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appHighlight]',
})
export class CollapsedStepsDirective {
  @Input('appHighlight') collapsedSteps: boolean = false;
  @Input() savedSteps: number = 0;
  @Input() uberAprovePrefilter!: boolean;
  @Input() canPassStep = false;
  @Input() creditType!: string;
  @Input() hideStepUber!: boolean;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.changeStyle();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.changeStyle();
  }

  changeStyle() {
    setTimeout(() => {
      const stepsChildren = this.el.nativeElement.children;

      if (stepsChildren?.length) {
        const displayStyle = this.collapsedSteps ? 'none' : 'initial';

        if (
          !this.uberAprovePrefilter &&
          this.savedSteps === 1 &&
          this.creditType === '1'
        ) {
          for (let i = 0; i < this.savedSteps; i++) {
            stepsChildren[i].style.display = displayStyle;
          }
        }

        if (
          !this.uberAprovePrefilter &&
          this.savedSteps === 2 &&
          this.creditType === '1'
        ) {
          for (let i = 0; i < this.savedSteps - 1; i++) {
            stepsChildren[i].style.display = displayStyle;
          }
        }
        if (
          this.uberAprovePrefilter &&
          this.savedSteps === 2 &&
          this.creditType === '1'
        ) {
          for (let i = 0; i < this.savedSteps; i++) {
            stepsChildren[i].style.display = displayStyle;
          }
        }

        if (
          this.uberAprovePrefilter &&
          !this.canPassStep &&
          this.creditType === '1' &&
          this.savedSteps === 3
        ) {
          for (let i = 0; i < this.savedSteps; i++) {
            stepsChildren[i].style.display = displayStyle;
          }
        }

        if (
          this.uberAprovePrefilter &&
          !this.canPassStep &&
          this.creditType === '1' &&
          this.savedSteps === 4
        ) {
          for (let i = 0; i < this.savedSteps - 1; i++) {
            stepsChildren[i].style.display = displayStyle;
          }
        }

        if (
          this.uberAprovePrefilter &&
          this.canPassStep &&
          this.creditType === '1'
        ) {
          for (let i = 0; i < this.savedSteps; i++) {
            stepsChildren[i].style.display = displayStyle;
          }
        }

        if (
          !this.uberAprovePrefilter &&
          this.creditType === '9' &&
          this.savedSteps === 3
        ) {
          for (let i = 0; i < this.savedSteps - 1; i++) {
            stepsChildren[i].style.display = displayStyle;
          }
        }

        if (
          !this.uberAprovePrefilter &&
          this.creditType === '9' &&
          this.savedSteps != 3 &&
          !this.hideStepUber
        ) {
          for (let i = 0; i < this.savedSteps; i++) {
            stepsChildren[i].style.display = displayStyle;
          }
        }

        if (this.uberAprovePrefilter && this.creditType === '9') {
          for (let i = 0; i < this.savedSteps; i++) {
            stepsChildren[i].style.display = displayStyle;
          }
        }
        if (
          this.hideStepUber &&
          this.creditType === '9' &&
          this.savedSteps === 4
        ) {
          for (let i = 0; i < this.savedSteps - 1; i++) {
            stepsChildren[i].style.display = displayStyle;
          }
        }

        if (
          this.hideStepUber &&
          this.creditType === '9' &&
          this.savedSteps != 4
        ) {
          for (let i = 0; i < this.savedSteps; i++) {
            stepsChildren[i].style.display = displayStyle;
          }
        }
      }
    }, 0);
  }
}
